exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*styles for home content only*/\n.profile-wrapper {\n  margin-top: 1px;\n}\n.no-padding\n{\n  padding: 0px;\n}\n#company-profile {\n\n  width: 100%;\n  min-height: 300px;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  float: left;\n\n}\n\n#service-list {\n  width: 100%;\n  float: left;\n}\n\n.offix {\n  position: fixed;\n  top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/servantListHome/servantListHome.component.css
// module id = 912
// module chunks = 3